import { Localized } from "@fluent/react"
import { Alert, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, Stack, Typography } from "@mui/material"
import { useState } from "react";
import { SaveButton } from "../../../app/components/SaveButton";
import { CancelButton } from "../../../app/components/CancelButton";
import { showError, showSuccess } from "../../notifications/notificationsSlice";
import { useAppDispatch } from "../../../app/hooks";
import { CompanyMapping, createCompanyMapping } from "./CompanyMappingsApi";
import { Company } from "../companiesSlice";
import { Supplier } from "../../suppliers/suppliersSlice";
import { SuppliersDataGrid } from "./SuppliersDataGrid";

interface CreateCompanyMappingDialogProps {
    companyId?: string;
    companies: Company[],
    suppliers: Supplier[],
    onSaveSuccess: (companySetting: CompanyMapping) => void;
    onCancel: () => void;
}

export const CreateCompanyMappingDialog: React.FC<CreateCompanyMappingDialogProps> = ({ companyId, companies, suppliers, onSaveSuccess, onCancel }) => {
    const dispatch = useAppDispatch();
    const [supplier, setSupplier] = useState<string>("");
    const [company, setCompany] = useState<string>(companyId ?? "");

    const [serverError, setServerError] = useState("");
    const [saving, setSaving] = useState<boolean>(false);

    const handleSupplierChange = (rowId) => {
        console.log(rowId)
        setSupplier(rowId);
    }
    const handleCompanyChange = (event) => setCompany(event.target.value);

    const handleConfirm = async () => {
        try {
            const result = await dispatch(createCompanyMapping({ supplierId: supplier, companyId: company }))
            if (createCompanyMapping.fulfilled.match(result)) {
                dispatch(showSuccess("saved"))
                onSaveSuccess(result.payload);
            } else {
                let errorMsg = "error"
                if (result.payload && result.payload.kind === 'http') {
                    const problem = result.payload.problem
                    if (problem) {
                        errorMsg = problem.title

                    }
                }
                setServerError(errorMsg)
            }
        }
        catch (error) {
            dispatch(showError("error"));
        }
        finally {
            setSaving(false)
        }
    }

    return (
        <>
            <DialogTitle>
                <Localized id="company-supplier-mappings-create-new">
                    <span>_Dodaj nowe mapowanie</span>
                </Localized>
            </DialogTitle>
            <DialogContent>
                <Stack direction="column" spacing={2} padding={2}>
                    <FormControl>
                        <InputLabel id="select-company-label"><Localized id="company-supplier-mappings-company">_Firma zarejestrowana w systemie</Localized></InputLabel>
                        <Select
                            labelId="select-company-label"
                            value={company}
                            onChange={handleCompanyChange}
                            label={<Localized id="company-supplier-mappings-company">_Firma zarejestrowana w systemie</Localized>}
                            disabled={companyId !== undefined}
                        >
                            {companies.map((option) =>
                                <MenuItem value={option.id}>{option.name}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <Typography align="center">
                        <Localized id="company-supplier-mappings-suppliers">_Dostawcy klientów</Localized>
                    </Typography>
                    <SuppliersDataGrid suppliers={suppliers} onRowSelected={handleSupplierChange} />
                </Stack>
                {
                    serverError && <Alert sx={{ marginTop: 1, }} onClose={() => { setServerError("") }} severity="error">
                        <Localized id={serverError}>
                            <span>Server error</span>
                        </Localized>
                    </Alert>
                }
            </DialogContent>
            <DialogActions>
                <SaveButton loading={saving} onClick={handleConfirm} />
                <CancelButton loading={saving} onClick={onCancel} />
            </DialogActions>
        </>               
    )
}